import { Container } from "@octopus-energy/coral/atoms"
import CustomHead from "@/components/atoms/CustomHead"
import { StoryblokBlokLooper } from "@/features/storyblok/components/StoryblokBlokLooper"
import { type SbBlogHomePageStory } from "@/features/storyblok/types"

type Props = {
    story: SbBlogHomePageStory
}

export function BlogHeader({ story }: Props) {
    const { metadata, blocks } = story.content

    return (
        <>
            <CustomHead
                title={metadata?.title ?? "Blog"}
                description={metadata?.description}
            />
            <Container marginBottom="md">
                <StoryblokBlokLooper blocks={blocks} />
            </Container>
        </>
    )
}
